import { Button, Grid, IconButton, styled, TextField } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import React from 'react';
import { DocumentData } from '../../../../services/apiTypes';
import { useTranslation } from 'react-i18next';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

type DisplayDocumentProps = {
  files: [
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
    {
      id: number;
      fileName?: string;
      file?: File;
      isImage: boolean;
    },
  ];
  index: number;
  setDocument: (index: number, file?: File) => void;
  documents: DocumentData[];
};

const DisplayDocument: React.FC<DisplayDocumentProps> = ({
  files,
  index,
  setDocument,
}) => {
  const { t } = useTranslation();

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      setDocument(index, undefined);
      return;
    }
    setDocument(index, file);
    // アップロードするとstateの更新に関わらずinput要素のvalueはセットされる
    // 連続で同じファイルをアップロードすると
    // valueが変わらずonChangeが発火しないため都度リセットする
    event.target.value = '';
  };

  return (
    <React.Fragment>
      <Grid size={6}>
        <IconButton
          onClick={() => setDocument(index, undefined)}
          className="hover-button2"
          sx={{
            position: 'absolute',
            right: '-15px',
            top: '-15px',
            bgcolor: '#FFF',
            display: 'none',
            width: '36px',
            height: '36px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ClearSharpIcon />
        </IconButton>
      </Grid>

      <Grid
        size={12}
        container
        justifyContent={'center'}
        alignContent={'center'}
        height={'180px'}
      >
        <Grid size={9} mb={3}>
          <TextField
            fullWidth
            size="small"
            disabled
            placeholder={t('LBL_NO_FILES_SELECTED')}
            value={files[index]?.fileName}
          ></TextField>
        </Grid>
        <Grid size={9}>
          <Button
            component="label"
            role={undefined}
            variant="contained"
            fullWidth
            sx={{ bgcolor: '#fff', color: '#000', textTransform: 'none' }}
            tabIndex={-1}
            endIcon={<FolderIcon color="primary" />}
          >
            {t('BTN_DOCUMENT_UPLOAD')}
            <VisuallyHiddenInput type="file" onChange={onChangeFile} />
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default DisplayDocument;
